import React from "react";
import { inject, observer } from "mobx-react";
import { SaveAlt } from "@material-ui/icons";
import "./downloadDocuments.scss";
import { Button } from "@material-ui/core";
import { DocumentStore, FilesKeys } from "../../../stores/documentStore";
import Notification from "../notification/notification";
import JSZip from "jszip";
import FileSaver from "file-saver";
import { PolicyStore } from "../../../stores/policyStore";
import { DocumentService } from "../../../services/services/documentService";

interface DownloadDocumentsProps {
  documentStore?: DocumentStore;
  documentService?: DocumentService;
  policyStore?: PolicyStore;
  onClick: (success: boolean) => void;
  displayAdditionalInfo?: boolean;
  displayPolicyInfo?: boolean;
  buttonLabel: string;
  downloadFiles: FilesKeys[];
}

@inject("documentStore", "documentService", "policyStore")
@observer
export default class DownloadDocuments extends React.Component<DownloadDocumentsProps> {
  constructor(props: any) {
    super(props);

    this.props.documentStore!.resetFilesMap();
  }

  public componentDidMount() {
    this.downloadAllPdfs();
  }

  public render() {
    return (
      <div className="download-button-wrapper">
        {this.props.displayPolicyInfo && (
          <Notification
            type="error"
            className="policy-info"
            message="Aby wystawić polisę pobierz Kartę produktu, OWU i Formularz informacyjny"
          />
        )}
        <Button className="download-button"
          disabled={!this.isPdfRequestDone()}
          onClick={() => this.onClick()}>
          {this.props.buttonLabel}<SaveAlt />
        </Button>
        {this.props.displayAdditionalInfo && (
          <label>
            Po wciśnięciu przycisku powinny zostać pobrane wszystkie dokumenty dla danej polisy
          </label>
        )}
      </div>
    );
  }

  private downloadAllPdfs() {
    for (const key in this.props.downloadFiles) {
      if (!this.props.downloadFiles.hasOwnProperty(key)) {
        continue;
      }
      this.props.documentService!.downloadPdf(this.props.downloadFiles[key]);
    }
  }

  private async onClick() {
    let failed = false;
    const downloadedFiles: FilesKeys[] = [];

    for (const key in this.props.downloadFiles) {
      if (!this.props.downloadFiles.hasOwnProperty(key)) {
        continue;
      }

      const file = this.props.downloadFiles[key];
      if (this.props.documentStore!.getFileRequestStatus(file)!.isError) {
        await this.props.documentService!.downloadPdf(file);
        if (this.props.documentStore!.getFileRequestStatus(file)!.isError) {
          failed = true;
        } else {
          downloadedFiles.push(file);
        }
      } else {
        downloadedFiles.push(file);
      }
    }

    if (!failed) {
      this.props.onClick(true);
      this.saveDocumentsOnUserPc(downloadedFiles);
    } else {
      this.props.onClick(false);
    }
  }

  private saveDocumentsOnUserPc(downloadedFiles: FilesKeys[]) {
    const documentStore = this.props.documentStore!;
    const zip = new JSZip();

    downloadedFiles.forEach((fileKey: FilesKeys) => {
      zip.file(documentStore.getFileName(fileKey), documentStore.getFileBlob(fileKey));
    });

    zip.generateAsync({ type: "blob" }).then(blob => {
      const policyNumber = this.props.policyStore!.policyResponse.policyNumber;
      const fileName = policyNumber ?
        `Załączniki do ubezpieczenia Bezpieczny Dom ${policyNumber}.zip` :
        "Załączniki do ubezpieczenia Bezpieczny Dom.zip";

      if (blob) {
        FileSaver.saveAs(blob, fileName);
      }
    }).catch((error) => {
      // tslint:disable-next-line:no-console
      console.log("Błąd: ", error);
    });
  }

  private isPdfRequestDone() {
    let done = true;

    this.props.downloadFiles.forEach((key: FilesKeys) => {
      if (!this.requestSucceeded(key)) {
        done = false;
      }
    });

    return done;
  }

  private requestSucceeded(key: FilesKeys) {
    return !this.props.downloadFiles.includes(key) ||
      (this.props.downloadFiles.includes(key) && this.props.documentStore!.getFileRequestStatus(key).isDone);
  }
}
